import React from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Link } from '@mui/material';
import IPhotographer from './IPhotographer';
import IPresentation from './IPresentation';

interface Props {
    presentation: IPresentation;
    photographer: IPhotographer;
};

const PortfolioModalLeft: React.FunctionComponent<Props> = ({ photographer, presentation }) => {

    const { apiUrl } = window.appConfig;

    const typographyName = {
        fontSize: '20px',
        color: '#242C30',
        pl: 2,
        fontFamily: "'Gilroy', sans-serif",
        fontWeight: 700
    }

    const instagramIcon = {
        fontSize: '21px',
        fill: 'rgba(0, 0, 0, 0.54);',
        mr: '16px',
    }

    const flexRowAlignCenter = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    }

    return (
        <>
            <Box
                sx={flexRowAlignCenter}
            >
                <Box
                    sx={{
                        width: '100px',
                        aspectRatio: '1',
                        backgroundImage:
                            presentation.profileImageReference
                                ? `url(${apiUrl}/file/${presentation.profileImageReference})`
                                : 'url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNTAgMjUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI2Ni40MyAtNDAxLjY1KSI+CiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoLjY4MzMzIDAgMCAuNjgzMzMgNTgxLjk0IDU1MC43NykiIGZpbGw9IiNEREREREQiPgogICA8cmVjdCB4PSItNDYxLjczIiB5PSItMjE4LjIzIiB3aWR0aD0iMzY1Ljg1IiBoZWlnaHQ9IjM2NS44NSIgcng9IjAiIHJ5PSIwIiBjb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0RERERERCIvPgogIDwvZz4KICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCguMzQ5MiAwIDAgLjM0OTIgMjg0LjU3IDQxOS43OSkiIGZpbGw9IiNGRkYiPgogICA8ZyBmaWxsPSIjRkZGIj4KICAgIDxwYXRoIGQ9Im0zMDYgMzI1Ljk5YzkwLjU2LTAuMDEgMTIzLjE1LTkwLjY4IDEzMS42OC0xNjUuMTcgMTAuNTEtOTEuNzYtMzIuODgtMTYwLjgyLTEzMS42OC0xNjAuODItOTguNzggMC0xNDIuMTkgNjkuMDU1LTEzMS42OCAxNjAuODIgOC41NCA3NC40ODQgNDEuMTE0IDE2NS4xOCAxMzEuNjggMTY1LjE3eiIvPgogICAgPHBhdGggZD0ibTU1MC45OCA1NDEuOTFjLTAuOTktMjguOTA0LTQuMzc3LTU3LjkzOS05LjQyMS04Ni4zOTMtNi4xMTEtMzQuNDY5LTEzLjg4OS04NS4wMDItNDMuOTgzLTEwNy40Ni0xNy40MDQtMTIuOTg4LTM5Ljk0MS0xNy4yNDktNTkuODY1LTI1LjA4MS05LjY5Ny0zLjgxLTE4LjM4NC03LjU5NC0yNi41MzctMTEuOTAxLTI3LjUxOCAzMC4xNzYtNjMuNCA0NS45NjItMTA1LjE5IDQ1Ljk2NC00MS43NzQgMC03Ny42NTItMTUuNzg2LTEwNS4xNy00NS45NjQtOC4xNTMgNC4zMDgtMTYuODQgOC4wOTMtMjYuNTM3IDExLjkwMS0xOS45MjQgNy44MzItNDIuNDYxIDEyLjA5Mi01OS44NjMgMjUuMDgxLTMwLjA5NiAyMi40NjMtMzcuODczIDcyLjk5Ni00My45ODMgMTA3LjQ2LTUuMDQ1IDI4LjQ1NC04LjQzMyA1Ny40ODktOS40MjIgODYuMzkzLTAuNzY2IDIyLjM4NyAxMC4yODggMjUuNTI1IDI5LjAxNyAzMi4yODQgMjMuNDUzIDguNDU4IDQ3LjY2NiAxNC43MzcgNzIuMDQxIDE5Ljg4NCA0Ny4wNzcgOS45NDEgOTUuNjAzIDE3LjU4MiAxNDMuOTIgMTcuOTI0IDQ4LjMxOC0wLjM0MyA5Ni44NDQtNy45ODMgMTQzLjkyLTE3LjkyNCAyNC4zNzUtNS4xNDUgNDguNTktMTEuNDI0IDcyLjA0MS0xOS44ODQgMTguNzM2LTYuNzU3IDI5Ljc4OS05Ljg5NSAyOS4wMjMtMzIuMjg0eiIvPgogICA8L2c+CiAgPC9nPgogPC9nPgo8L3N2Zz4K)',
                        backgroundSize: 'cover',
                        backgroundColor: '#b0b0b0'
                    }}
                >
                </Box>

                <Box>
                    <Typography aria-label='photographer-name' role='heading' display="block" sx={typographyName} className='portfolio-name'>
                        {photographer.name}
                    </Typography>
                </Box>
            </Box>
            {presentation.description
                ? <Typography my={4} sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.87)', whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} aria-label='photographer-description' role='heading'>
                    {presentation.description}
                </Typography>
                : null
            }
            {presentation.instagramLink
                ? <Box sx={flexRowAlignCenter}>
                    <InstagramIcon sx={instagramIcon} />
                    <Link target="_blank"
                        sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.87)' }}
                        underline="none"
                        href={`https://www.instagram.com/${presentation.instagramLink}`}
                        role="link"
                        aria-label='photographer-instagram' >
                        {presentation.instagramLink}
                    </Link>
                </Box>
                : null
            }

        </>
    )
}

export default PortfolioModalLeft